import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ChevronDoubleRightIcon,
  ChevronDoubleLeftIcon,
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import ApiBase from "../../redux/constent";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const customStyles = `
  .custom-brands-slider .slick-arrow {
    display: none !important;
  }
  .custom-brands-slider .slick-dots {
    display: none !important;
  }
  .custom-brands-slider .slick-track {
    display: flex;
    align-items: center;
  }
  .custom-brands-slider .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
  }
  .custom-brands-slider .slick-slide > div {
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  .custom-brands-slider .slick-list {
    margin: 0 -12px;
  }
`;

export default function CustomListBrands({ id }) {
  const sliderRef = useRef(null);
  const [brands, setBrands] = useState([]);
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const timerRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "linear",
    rtl: direction === "rtl",
    variableWidth: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
    ],
  };

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${ApiBase}/area/${id}`)
      .then((response) => {
        if (response.data?.data?.brand) {
          setBrands(response?.data?.data?.brand);
        }
      })
      .catch((error) => console.error("Error fetching brands:", error));
  }, [id]);

  const scrollOneItem = (direction) => {
    if (sliderRef.current && brands.length > 0) {
      if (direction === "left") {
        sliderRef.current.slickPrev();
      } else {
        sliderRef.current.slickNext();
      }
    }
  };

  const handleBrandClick = (brandLink) => {
    if (brandLink) {
      window.open(brandLink, "_blank");
    } else {
      console.error("Website link is unavailable.");
      alert(t("CannotNavigateWebsite"));
    }
  };

  const handlePause = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPause();
    }
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const handleResume = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickPlay();
      }
    }, 3000);
  };

  // Inject styles
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = customStyles;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  return (
    <div
      className="items-center justify-center pb-2"
      dir="ltr"
      onMouseEnter={handlePause}
      onMouseLeave={handleResume}
      onFocus={handlePause}
      onBlur={handleResume}
      onTouchStart={handlePause}
      onTouchEnd={handleResume}
      onTouchCancel={handleResume}
    >
      <div className="flex flex-col items-center justify-center text-center">
        <div className="relative flex items-center max-w-[320px] lg:max-w-[350px] md:max-w-[220px] mx-auto">
          {brands.length > 1 && (
            <button
              onClick={() => scrollOneItem("left")}
              className="absolute md:block hidden left-[-40px] z-10 p-2 rounded-full focus:outline-none"
            >
              <ChevronDoubleLeftIcon className="w-6 h-6 text-black" />
            </button>
          )}

          <div className="w-full h-full">
            {brands.length > 0 && (
              <Slider
                ref={sliderRef}
                {...sliderSettings}
                className="custom-brands-slider"
              >
                {brands.map((brand) => (
                  <div key={brand._id}>
                    <div className="flex-none rounded-lg ">
                      <div
                        onClick={() => handleBrandClick(brand.link)}
                        style={{ cursor: "pointer" }}
                        className="flex items-center h-full"
                      >
                        <img
                          src={brand.img}
                          alt={brand.name.en}
                          className="object-contain w-full h-auto max-h-16"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>

          {brands.length > 1 && (
            <button
              onClick={() => scrollOneItem("right")}
              className="absolute right-[-40px] md:block hidden z-10 p-2 rounded-full focus:outline-none"
            >
              <ChevronDoubleRightIcon className="w-6 h-6 text-black" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
